import { useState } from "react";
import { toast } from "sonner";

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const NotifyForm = ({ id = "notify-form", testIdPrefix = "hero", variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    // Static form — no backend submission per FSSAI pre-launch requirement.
    setTimeout(() => {
      setLoading(false);
      setEmail("");
      toast.success("You're on the list. We'll be in touch when we launch.");
    }, 700);
  };

  const isDark = variant === "dark";

  return (
    <form
      id={id}
      onSubmit={onSubmit}
      data-testid={`${testIdPrefix}-notify-form`}
      className="w-full max-w-xl"
    >
      <div className={`flex flex-col sm:flex-row items-stretch gap-0 sm:gap-0 border-b ${isDark ? "border-[#FDFBF7]/40" : "border-[#1A362D]/30"} pb-0`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          data-testid={`${testIdPrefix}-notify-email-input`}
          className={`flex-1 bg-transparent px-0 py-4 text-base md:text-lg outline-none placeholder:font-light ${
            isDark
              ? "text-[#FDFBF7] placeholder:text-[#FDFBF7]/50"
              : "text-[#1A362D] placeholder:text-[#4A5D56]/60"
          }`}
        />
        <button
          type="submit"
          disabled={loading}
          data-testid={`${testIdPrefix}-notify-submit-btn`}
          className={`group inline-flex items-center justify-center gap-2 px-7 py-4 mt-3 sm:mt-0 text-xs md:text-sm uppercase tracking-[0.2em] transition-colors duration-300 ${
            isDark
              ? "bg-[#FDFBF7] text-[#1A362D] hover:bg-[#C29B62] hover:text-[#FDFBF7]"
              : "bg-[#1A362D] text-[#FDFBF7] hover:bg-[#132720]"
          } disabled:opacity-60`}
        >
          {loading ? "Sending…" : "Notify Me"}
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">→</span>
        </button>
      </div>
      <p className={`mt-4 text-xs tracking-wide ${isDark ? "text-[#FDFBF7]/60" : "text-[#4A5D56]/80"}`}>
        Be the first to know when Activehuman Vitamin D3 Drops launch. We respect your inbox.
      </p>
    </form>
  );
};
